export default __webpack_public_path__ + "media/heart-o-orange.e046845a.svg";